/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star-filled': {
    width: 14,
    height: 12,
    viewBox: '0 0 14 12',
    data: '<path pid="0" d="M4.863 3.699l-3.88.553-.075.017a.437.437 0 00-.173.732l2.808 2.687-.663 3.797-.007.071a.447.447 0 00.655.392l3.47-1.794 3.472 1.794.066.028c.311.104.641-.156.582-.491l-.664-3.797 2.809-2.687.051-.057a.438.438 0 00-.298-.692l-3.881-.553L7.401.245a.45.45 0 00-.802 0L4.863 3.699z"/>'
  }
})
